import { Outlet, useNavigation } from 'react-router-dom';

import { Loader } from 'components';

export const Root = () => {
  const navigate = useNavigation();
  const isLoading = ['loading', 'submitting'].includes(navigate.state);

  return (
    <>
      {isLoading && <Loader />}
      <Outlet />
    </>
  );
};
